import { Fragment } from 'react';
import classNames from 'classnames';

import { extractCombineSteps } from '@/core/operation';
import { Icon } from '@/components/icon';
import { getPipelineTitle } from '@/explore/edit-pipeline/utils/format';

import { Exploration, JoinPipelineOperation, Model, Pipeline } from '../../types';

import * as style from './pipeline-preview.module.scss';

interface CombineHeaderProps {
  pipeline: Pipeline;
  operation: JoinPipelineOperation;
  models: Model[];
  exploration: Exploration;
}

export const CombineHeader = (props: CombineHeaderProps) => {
  const { pipeline, operation, models, exploration } = props;

  const leftTitle = getPipelineTitle(models, exploration, pipeline);
  const titles = extractCombineSteps(operation).map((step) =>
    getPipelineTitle(models, exploration, step.pipeline),
  );

  return (
    <div className={classNames(style.operation, style.combinedHeader)}>
      <div className={style.operationIcon}>
        <Icon name="Model" />
      </div>
      <div className={style.operationTitle}>{leftTitle}</div>
      {titles.map((rightTitle, i) => (
        <Fragment key={i}>
          <div className={style.operationIcon}>
            <Icon name="Plus" size={16} />
          </div>
          <div className={style.operationIcon}>
            <Icon name="Model" />
          </div>
          <div className={style.operationTitle}>{rightTitle}</div>
        </Fragment>
      ))}
    </div>
  );
};
